import React, { useEffect, useRef } from 'react';

const SessionTimeoutWarning = ({ show, onStay, onLogout, secondsLeft, language }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (show && modalRef.current) {
      modalRef.current.focus();
    }
  }, [show]);

  const text = {
    en: {
      title: 'Session Expiring Soon',
      message: `For your privacy, this session will end in ${secondsLeft} seconds unless you choose to continue.`,
      stay: 'Continue session',
      logout: 'Sign out now'
    },
    fr: {
      title: 'Votre session expirera bientôt',
      message: `Pour protéger votre confidentialité, cette session se terminera dans ${secondsLeft} secondes à moins que vous choisissiez de la poursuivre.`,
      stay: 'Poursuivre la session',
      logout: 'Se déconnecter maintenant'
    }
  };

  if (!show) return null;

  return (
    <div
      className="govuk-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-timeout-title"
      tabIndex="-1"
      ref={modalRef}
      style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <div style={{ background: 'white', padding: '2em', borderRadius: '8px', maxWidth: '90vw', outline: 'none' }}>
        <h2 id="session-timeout-title">{text[language].title}</h2>
        <p>{text[language].message}</p>
        <div style={{ display: 'flex', gap: '1em', marginTop: '1em' }}>
          <button className="govuk-button" onClick={onStay}>{text[language].stay}</button>
          <button className="govuk-button govuk-button--secondary" onClick={onLogout}>{text[language].logout}</button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutWarning;
